import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
export var TextFormatter = /*#__PURE__*/function () {
  function TextFormatter(value) {
    _classCallCheck(this, TextFormatter);

    this._value = !!value && /\S/.test(value) ? String(value) : "";
  }

  _createClass(TextFormatter, [{
    key: "value",
    get: function get() {
      return this._value;
    }
    /**
     * This function is needed to honor line breaks
     * @param {*} textValue - string
     */

  }, {
    key: "addLineBreaks",
    value: function addLineBreaks() {
      this._value.replace(/(?:\r\n|\r|\n)/g, "<br />");

      return this;
    }
    /**
     * This function is needed to normalize html and fix broken tags
     * @param {*} textValue - string
     */

  }, {
    key: "normalizeHtml",
    value: function normalizeHtml() {
      if (!this._value) {
        this._value = "";
        return this;
      } // Create a temporary DOM element to parse and auto-fix HTML


      var temp = document.createElement('div');
      temp.innerHTML = this._value; // The browser automatically fixes broken tags

      this._value = temp.innerHTML;
      return this;
    }
  }]);

  return TextFormatter;
}();